module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.2-261.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.7.2.md
// module id = 703
// module chunks = 248